var publicationScope = [
  {
    id:1,
    name:"图书"
  },
  {
    id:2,
    name:"报纸"
  },
  {
    id:3,
    name:"期刊"
  },
  {
    id:4,
    name:"音像制品"
  },
  {
    id:5,
    name:"电子出版物"
  },
  {
    id:6,
    name:"其他"
  }
]

export default publicationScope